export default class ScrollSpy {
  ticking = false;

  constructor(settings = {}) {
    const options = {
      headerClass: '.header',
      headerOffset: false,
      sectionSelector: '.js-spy',
      linkCurrentClass: 'current',
      linksContainerSelector: '.js-spy-nav',
      ...settings,
    };

    if (document.querySelector(options.sectionSelector)) {
      this.init(options);

      window.addEventListener('load', this.refreshPositions);
      window.addEventListener('resize', this.refreshPositions);

      return this;
    }
  }

  init = (options) => {
    // Prepare properties
    this.setProperties(options);

    // Fire up plugin
    this.getSectionData();
    this.getCurrentSectionIndex();
    this.setCurrentState();
    this.bindEvents();
  };

  setProperties = (options) => {
    const doc = document;

    this.linksContainerSelector = options.linksContainerSelector;
    this.sectionSelector = options.sectionSelector;
    this.linksContainer = doc.querySelector(this.linksContainerSelector);
    this.links = [...this.linksContainer.querySelectorAll('a[href^="#"]')];
    this.sections = [...doc.querySelectorAll(this.sectionSelector)];
    this.headerOffset = options.headerOffset;
    this.headerClass = options.headerClass;
    this.linkCurrentClass = options.linkCurrentClass;

    this.currentIdx = 0;
    this.data = {
      offsets: [],
      ids: [],
    };
  };

  getSectionData = () => {
    this.sections.forEach((section) => {
      this.data.ids.push(section.getAttribute('id'));
      this.data.offsets.push(this.getSectionOffset(section));
    });
  };

  refreshPositions = () => {
    this.data.offsets = this.data.offsets.map((offset, index) => {
      return this.getSectionOffset(this.sections[index]);
    });
  };

  getSectionOffset = (section) => {
    const offsetTop =
      section.offsetTop -
      Number.parseFloat(getComputedStyle(section).marginTop);

    if (!this.headerOffset) {
      return offsetTop;
    }

    return offsetTop - document.querySelector(this.headerClass).offsetHeight;
  };

  getCurrentSectionIndex = () => {
    const scrollTop = window.overlayScrollbar
      ? window.overlayScrollbar.scroll().position.y
      : window.pageYOffset;

    this.data.offsets.forEach((offset, index) => {
      const nextOffset = this.data.offsets[index + 1];

      if (
        (scrollTop >= offset && scrollTop < nextOffset) ||
        (scrollTop >= offset && typeof nextOffset === 'undefined')
      ) {
        this.currentIdx = index;
      }
    });

    this.setCurrentState();
  };

  setCurrentState = () => {
    document
      .querySelector(this.linksContainerSelector)
      .querySelectorAll(`.${this.linkCurrentClass}`)
      .forEach((item) => item.classList.remove(this.linkCurrentClass));

    const currentItem = this.links[this.currentIdx].parentNode;
    currentItem.classList.add(this.linkCurrentClass);

    let parentItem = currentItem.closest('li');
    parentItem.classList.add(this.linkCurrentClass);

    while (parentItem) {
      parentItem.classList.add(this.linkCurrentClass);

      parentItem = parentItem.parentNode.closest('li');
    }
  };

  scrollToCurrentSection = () => {
    window.scrollToPosition(this.data.offsets[this.currentIdx]);
  };

  bindEvents = () => {
    document.addEventListener('DOMContentLoaded', () => {
      this.links.forEach((link, index) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();

          this.currentIdx = index;
          this.scrollToCurrentSection();
        });
      });

      window.scrollEmitterElement.addEventListener('scroll', () => {
        this.getCurrentSectionIndex();
      });
    });
  };
}
